import React from 'react';

import { useEffect, useState } from "react";
import { FaMinus } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import CalvinLogo from "../../assets/Images/Calvin-Group-Logo-Bg.svg";
import {
    getAllMachinesCategoryList,
    getAllMachinesMaketList,
    getAllMachinesModelList,
    getMasterModelsByMake,
} from "../../services/machineService";
import { ApplicationId } from "../../api/url";

const FilterSidebar = ({
    selectedCategory,
    selectedMake,
    selectedModel,
    handelAddFilter,
    selectedMaxYear,
    selectedMinYear,
    selectedMinHours,
    selectedMaxHours,
    selectedMinPrice,
    selectedMaxPrice,
}) => {
    const [machinesTypeList, setMachinesTypeList] = useState([]);
    const [categoryLoading, setCategoryLoading] = useState(false);
    const [machinesMakeList, setMachinesMakeList] = useState([]);
    const [makeLoading, setMakeLoading] = useState(false);
    const [selectedTempCategory, setSelectedTempCategory] = useState([]);
    const [selectedTempMake, setSelectedTempMake] = useState([]);
    const [selectedTempModel, setSelectedTempModel] = useState([]);
    const [machinesModelList, setMachinesModelList] = useState([]);
    const [modelLoading, setModelLoading] = useState(false);

    const [categorySearchTerm, setCategorySearchTerm] = useState("");
    const [makeSearchTerm, setMakeSearchTerm] = useState("");

    const [selectedTempMaxYear, setSelectedTempMaxYear] = useState(null);
    const [selectedTempMinYear, setSelectedTempMinYear] = useState(null);
    const [selectedTempMaxHours, setSelectedTempMaxHours] = useState(null);
    const [selectedTempMinHours, setSelectedTempMinHours] = useState(null);
    const [selectedTempMaxPrice, setSelectedTempMaxPrice] = useState(null);
    const [selectedTempMinPrice, setSelectedTempMinPrice] = useState(null);

    const [expandedSections, setExpandedSections] = useState({
        category: false,
        make: false,
        model: false,
        year: false,
        hours: false,
        price: false,
    });

    useEffect(() => {
        GetMachinesTypeList();
        GetMachinesMakeList();
    }, []);

    useEffect(() => {
        if (selectedTempMake) {
            GetMachinesModelList();
        }
    }, [selectedTempMake]);

    useEffect(() => {
        setSelectedTempCategory(selectedCategory);
    }, [selectedCategory]);

    useEffect(() => {
        setSelectedTempMake(selectedMake);
    }, [selectedMake]);

    useEffect(() => {
        setSelectedTempModel(selectedModel);
    }, [selectedModel]);

    useEffect(() => {
        setSelectedTempMaxYear(selectedMaxYear);
    }, [selectedMaxYear]);

    useEffect(() => {
        setSelectedTempMinYear(selectedMinYear);
    }, [selectedMinYear]);

    useEffect(() => {
        setSelectedTempMaxHours(selectedMaxHours);
    }, [selectedMaxYear]);

    useEffect(() => {
        setSelectedTempMinHours(selectedMinHours);
    }, [selectedMinHours]);
    useEffect(() => {
        setSelectedTempMaxPrice(selectedMaxPrice);
    }, [selectedMaxPrice]);

    useEffect(() => {
        setSelectedTempMinPrice(selectedMinPrice);
    }, [selectedMinPrice]);

    const toggleSection = (section) => {
        setExpandedSections((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };

    const GetMachinesTypeList = (val) => {
        setCategoryLoading(true);
        getAllMachinesCategoryList()
            .then((res) => {
                setCategoryLoading(false);
                const categoryDetails = res?.data
                    ?.find((item) => item.AssetTypeId === 2)
                    ?.CategoryDetails || [];

                // Filter categories that have at least one listing (TotalCount > 0)
                const categoriesWithListings = categoryDetails
                    .sort((a, b) => a?.CategoryName.localeCompare(b?.CategoryName));

                setMachinesTypeList(categoriesWithListings);
            })
            .catch((err) => {
                setCategoryLoading(false);
                console.log(err);
            });
    };

    const GetMachinesMakeList = (val) => {
        setMakeLoading(true);
        getAllMachinesMaketList(true)
            .then((res) => {
                setMakeLoading(false);
                setMachinesMakeList(res?.data?.sort((a, b) => a?.MakeName.localeCompare(b?.MakeName)));
            })
            .catch((err) => {
                setMakeLoading(false);
                console.log(err);
            });
    };

    const GetMachinesModelList = () => {
        setModelLoading(true);
        setMachinesModelList([]);

        const makeNames = selectedTempMake?.map((item) => item.MakeName);

        const payload = {
            applicationId: ApplicationId,
            makeName: makeNames,
            isFromAdvertisement: true
        };

        getMasterModelsByMake(payload)
            .then((res) => {
                setModelLoading(false);
                setMachinesModelList(res?.data || []);
            })
            .catch((err) => {
                setModelLoading(false);
                console.log(err);
                setMachinesModelList([]);
            });
    };

    const handelTempRemoveCategory = (ID) => {
        const removeCategory = selectedTempCategory.filter((item) => item.CategoryId !== ID);
        setSelectedTempCategory(removeCategory);
    };

    const handelTempRemoveMake = (ID) => {
        const removeMake = selectedTempMake.filter((item) => item.MakeId !== ID);
        setSelectedTempMake(removeMake);
    };

    const handelTempAddCategory = (value) => {
        setSelectedTempCategory([...selectedTempCategory, value]);
    };

    const handelTempAddMake = (value) => {
        setSelectedTempMake([...selectedTempMake, value]);
    };

    const handelTempRemoveModel = (ID) => {
        const removeModel = selectedTempModel.filter((item) => item !== ID);
        setSelectedTempModel(removeModel);
    };

    const handelTempAddModel = (value) => {
        setSelectedTempModel([...selectedTempModel, value]);
    };
    const handelNumberPointAllow = (value, setValue) => {
        const regex = /^\d*\.?\d{0,2}$/;
        if (regex.test(value)) {
            setValue(value);
        }
    };
    const handelNumberAllow = (value, setValue) => {
        const regex = /^\d*$/; // Allows only numbers (no decimal point)
        if (regex.test(value)) {
            setValue(value);
        }
    };

    const YearError =
        selectedTempMinYear !== "" &&
        selectedTempMinYear !== null &&
        selectedTempMaxYear !== "" &&
        selectedTempMaxYear !== null &&
        Number(selectedTempMinYear) > Number(selectedTempMaxYear);

    const HoursError =
        selectedTempMinHours !== "" &&
        selectedTempMinHours !== null &&
        selectedTempMaxHours !== "" &&
        selectedTempMaxHours !== null &&
        Number(selectedTempMinHours) > Number(selectedTempMaxHours);

    const PriceError =
        selectedTempMinPrice !== "" &&
        selectedTempMinPrice !== null &&
        selectedTempMaxPrice !== "" &&
        selectedTempMaxPrice !== null &&
        Number(selectedTempMinPrice) > Number(selectedTempMaxPrice);

    const FilterValidation = YearError || PriceError || HoursError;

    return (
        <div>
            <div className="w-full shadow-lg border rounded-lg">
                {/* Filter Header */}
                <div className="bg-[#FEBA06] h-[30px] rounded-t-lg"></div>
                <div className="p-4">
                    {/* Category */}
                    <div className="py-2 border-b flex items-center justify-between">
                        <span className="font-bold text-[20px] text-[#161412]">CATEGORY</span>
                        <button onClick={() => toggleSection("category")}>
                            {expandedSections.category ? (
                                <FaMinus className="text-[#FEBA06]" size={"28px"} />
                            ) : (
                                <FaPlus className="text-[#FEBA06]" size={"28px"} />
                            )}
                        </button>
                    </div>
                    {expandedSections.category && (
                        <div className="p-2 space-y-1">
                            {/* Search input for Category */}
                            <div className="mb-3">
                                <input
                                    type="text"
                                    placeholder="Search category..."
                                    className="w-full border border-[#feba0685] py-[8px] px-[12px] text-sm rounded outline-none focus:border-[#FEBA06] transition-colors text-[#161412] placeholder:text-[#A9A9A9]"
                                    value={categorySearchTerm}
                                    onChange={(e) => setCategorySearchTerm(e.target.value)}
                                />
                            </div>
                            {categoryLoading ? (
                                <div className="flex justify-center items-center py-4">
                                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#FEBA06]"></div>
                                </div>
                            ) : machinesTypeList?.length > 0 ? (
                                <div className="max-h-[300px] overflow-y-auto">
                                    {machinesTypeList?.filter((item) =>
                                        item.CategoryName.toLowerCase().includes(categorySearchTerm.toLowerCase())
                                    ).map((item, index) => {
                                        const isSelected = selectedTempCategory.some(
                                            (selectedItem) => selectedItem.CategoryId === item.CategoryId
                                        );
                                        return (
                                            <label key={index} className="flex items-center justify-between text-[#161412] cursor-pointer hover:bg-gray-100 p-1 rounded">
                                                <div className="flex items-center flex-1">
                                                    <input
                                                        type="checkbox"
                                                        className="mr-2 text-[#161412] cursor-pointer"
                                                        checked={isSelected}
                                                        onChange={() =>
                                                            isSelected ? handelTempRemoveCategory(item.CategoryId) : handelTempAddCategory(item)
                                                        }
                                                    />
                                                    <span className="flex-1">{item.CategoryName}</span>
                                                </div>
                                                {item.TotalCount > 0 && (
                                                    <span className="ml-2 px-2 py-0.5 text-xs bg-[#FEBA06] text-white rounded-full">
                                                        {item.TotalCount}
                                                    </span>
                                                )}
                                            </label>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div className="text-center text-gray-500 text-[16px] py-4">
                                    {categorySearchTerm ? "No matching categories found" : "No categories available"}
                                </div>
                            )}
                        </div>
                    )}

                    {/* Make */}
                    <div className="py-2 border-b flex items-center justify-between">
                        <span className="font-bold text-[20px]  text-[#161412]">MAKE</span>
                        <button onClick={() => toggleSection("make")}>
                            {expandedSections.make ? (
                                <FaMinus className="text-[#FEBA06]" size={"28px"} />
                            ) : (
                                <FaPlus className="text-[#FEBA06]" size={"28px"} />
                            )}
                        </button>
                    </div>
                    {expandedSections.make && (
                        <div className="p-2 space-y-1">
                            {/* Search input for Make */}
                            <div className="mb-3">
                                <input
                                    type="text"
                                    placeholder="Search make..."
                                    className="w-full border border-[#feba0685] py-[8px] px-[12px] text-sm rounded outline-none focus:border-[#FEBA06] transition-colors text-[#161412] placeholder:text-[#A9A9A9]"
                                    value={makeSearchTerm}
                                    onChange={(e) => setMakeSearchTerm(e.target.value)}
                                />
                            </div>
                            {makeLoading ? (
                                <div className="flex justify-center items-center py-4">
                                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#FEBA06]"></div>
                                </div>
                            ) : machinesMakeList?.length > 0 ? (
                                <div className="max-h-[300px] overflow-y-auto">
                                    {machinesMakeList?.filter((item) =>
                                        item.MakeName.toLowerCase().includes(makeSearchTerm.toLowerCase())
                                    ).map((item, index) => {
                                        const isSelected = selectedTempMake.some((selectedItem) => selectedItem.MakeId === item.MakeId);
                                        return (
                                            <label key={index} className="flex items-center text-[#161412] cursor-pointer hover:bg-gray-100 p-1 rounded">
                                                <input
                                                    type="checkbox"
                                                    className="mr-2 text-[#161412] cursor-pointer"
                                                    checked={isSelected}
                                                    onChange={() => (isSelected ? handelTempRemoveMake(item.MakeId) : handelTempAddMake(item))}
                                                />
                                                <span className="flex-1">{item.MakeName}</span>
                                            </label>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div className="text-center text-gray-500 text-[16px] py-4">
                                    {makeSearchTerm ? "No matching makes found" : "No makes available"}
                                </div>
                            )}
                        </div>
                    )}

                    {/* Model */}
                    <div className="py-2 border-b flex items-center justify-between">
                        <span className="font-bold text-[20px]  text-[#161412]">MODEL</span>
                        <button onClick={() => toggleSection("model")}>
                            {expandedSections.model ? (
                                <FaMinus className="text-[#FEBA06]" size={"28px"} />
                            ) : (
                                <FaPlus className="text-[#FEBA06]" size={"28px"} />
                            )}
                        </button>
                    </div>

                    {expandedSections.model && (
                        <div className="p-2 space-y-1">
                            {modelLoading ? (
                                <div className="flex justify-center items-center py-4">
                                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#FEBA06]"></div>
                                </div>
                            ) : selectedTempMake?.length === 0 ? (
                                <div className="text-center text-gray-500 text-[16px] py-4">
                                    Please select a make first to view models
                                </div>
                            ) : machinesModelList?.length > 0 ? (
                                <div className="max-h-[300px] overflow-y-auto">
                                    {machinesModelList?.map((item, index) => {
                                        const isSelected = selectedTempModel.some((selectedItem) => selectedItem === item.ModelName);
                                        return (
                                            <label key={index} className="flex items-center text-[#161412] cursor-pointer hover:bg-gray-100 p-1 rounded">
                                                <input
                                                    type="checkbox"
                                                    className="mr-2 text-[#161412] cursor-pointer"
                                                    checked={isSelected}
                                                    onChange={() =>
                                                        isSelected ? handelTempRemoveModel(item.ModelName) : handelTempAddModel(item.ModelName)
                                                    }
                                                />
                                                <span className="flex-1">{item.ModelName}</span>
                                            </label>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div className="text-center text-gray-500 text-[16px] py-4">
                                    No models found for selected make(s)
                                </div>
                            )}
                        </div>
                    )}

                    {/* Year */}
                    <div className="border-b">
                        <div className="py-2 flex items-center justify-between">
                            <span className="font-bold text-[20px]  text-[#161412]">YEAR</span>
                            <button onClick={() => toggleSection("year")}>
                                {expandedSections.year ? (
                                    <FaMinus className="text-[#FEBA06]" size={"28px"} />
                                ) : (
                                    <FaPlus className="text-[#FEBA06]" size={"28px"} />
                                )}
                            </button>
                        </div>
                        {expandedSections.year && (
                            <div className="mx-[0px] md:mx-[20px] pb-5">
                                <div className="p-2 flex items-center space-x-2">
                                    <input
                                        type="text"
                                        placeholder="Min Year"
                                        className={`${YearError ? "border-[#f44336]" : "border-[#feba0685]"
                                            } border py-[5px] px-[10px] text-sm w-full text-[15px] text-[#A9A9A9] outline-none`}
                                        value={selectedTempMinYear}
                                        onChange={(e) => handelNumberAllow(e.target.value, setSelectedTempMinYear)}
                                    />
                                    <span>-</span>
                                    <input
                                        type="text"
                                        placeholder="Max Year"
                                        className={`${YearError ? "border-[#f44336]" : "border-[#feba0685]"
                                            } border py-[5px] px-[10px] text-sm w-full text-[15px] text-[#A9A9A9] outline-none`}
                                        value={selectedTempMaxYear}
                                        onChange={(e) => handelNumberAllow(e.target.value, setSelectedTempMaxYear)}
                                    />
                                </div>

                                {YearError ? <div className=" p-2  text-[#f44336]">Min year must be less than max year</div> : null}
                            </div>
                        )}
                    </div>

                    {/* Hours */}
                    <div className="border-b">
                        <div className="py-2 flex items-center justify-between">
                            <span className="font-bold text-[20px]  text-[#161412]">HOURS</span>
                            <button onClick={() => toggleSection("hours")}>
                                {expandedSections.hours ? (
                                    <FaMinus className="text-[#FEBA06]" size={"28px"} />
                                ) : (
                                    <FaPlus className="text-[#FEBA06]" size={"28px"} />
                                )}
                            </button>
                        </div>
                        {expandedSections.hours && (
                            <div className="mx-[0px] md:mx-[20px] pb-5">
                                <div className="p-2 flex items-center space-x-2">
                                    <input
                                        type="text"
                                        placeholder="Hours"
                                        value={selectedTempMinHours}
                                        className={`${HoursError ? "border-[#f44336]" : "border-[#feba0685]"
                                            } border py-[5px] px-[10px] text-sm w-full text-[15px] text-[#A9A9A9] outline-none`}
                                        onChange={(e) => handelNumberPointAllow(e.target.value, setSelectedTempMinHours)}
                                    />
                                    <span>-</span>
                                    <input
                                        type="text"
                                        placeholder="Hours"
                                        value={selectedTempMaxHours}
                                        className={`${HoursError ? "border-[#f44336]" : "border-[#feba0685]"
                                            } border py-[5px] px-[10px] text-sm w-full text-[15px] text-[#A9A9A9] outline-none`}
                                        onChange={(e) => handelNumberPointAllow(e.target.value, setSelectedTempMaxHours)}
                                    />
                                </div>
                                {HoursError ? <div className=" p-2  text-[#f44336]">Min Hours must be less than max Hours</div> : null}
                            </div>
                        )}
                    </div>

                    {/* Price */}
                    <div className="border-b">
                        <div className="py-2  flex items-center justify-between">
                            <span className="font-bold text-[20px]  text-[#161412]">PRICE</span>
                            <button onClick={() => toggleSection("price")}>
                                {expandedSections.price ? (
                                    <FaMinus className="text-[#FEBA06]" size={"28px"} />
                                ) : (
                                    <FaPlus className="text-[#FEBA06]" size={"28px"} />
                                )}
                            </button>
                        </div>
                        {expandedSections.price && (
                            <div className="mx-[0px] md:mx-[20px] pb-5">
                                <div className="p-2 flex items-center space-x-2">
                                    <input
                                        type="text"
                                        placeholder="Min Price"
                                        value={selectedTempMinPrice}
                                        onChange={(e) => handelNumberPointAllow(e.target.value, setSelectedTempMinPrice)}
                                        className={`${PriceError ? "border-[#f44336]" : "border-[#feba0685]"
                                            } border py-[5px] px-[10px] text-sm w-full text-[15px] text-[#A9A9A9] outline-none`}
                                    />
                                    <span>-</span>
                                    <input
                                        type="text"
                                        placeholder="Max Price"
                                        className={`${PriceError ? "border-[#f44336]" : "border-[#feba0685]"
                                            } border py-[5px] px-[10px] text-sm w-full text-[15px] text-[#A9A9A9] outline-none`}
                                        value={selectedTempMaxPrice}
                                        onChange={(e) => handelNumberPointAllow(e.target.value, setSelectedTempMaxPrice)}
                                    />
                                </div>
                                {PriceError ? <div className=" p-2  text-[#f44336]">Min Price must be less than max Price</div> : null}
                            </div>
                        )}
                    </div>
                </div>

                {/* Filter Button */}
                <div className="flex justify-center mt-[150px]">
                    <button
                        className={`${FilterValidation ? "cursor-not-allowed" : "cursor-pointer"
                            } bg-[#FEBA06]  py-[13px] px-[39px] font-bold rounded-t-lg text-[#161412]`}
                        onClick={() => {
                            window.scrollTo({ top: 10, behavior: "smooth" });
                            handelAddFilter(
                                selectedTempCategory,
                                selectedTempMake,
                                selectedTempModel,
                                selectedTempMaxYear,
                                selectedTempMinYear,
                                selectedTempMaxHours,
                                selectedTempMinHours,
                                selectedTempMaxPrice,
                                selectedTempMinPrice
                            );
                        }}
                        disabled={FilterValidation}
                    >
                        FILTER
                    </button>
                </div>
            </div>

            <div className="my-[22px]">
                <img src={CalvinLogo} alt="" width={"100%"} />
            </div>
        </div>
    );
};

export default FilterSidebar;
